// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client'; // Solo usamos createRoot
import './index.css';
import App from './App.js';
import { ThemeProvider } from "@mui/material/styles/index.js";
import theme from "./theme.js";
import { AuthProvider } from './context/AuthContext.js';
import '@fortawesome/fontawesome-free/css/all.min.css';

// Registro del Service Worker
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/firebase-messaging-sw.js')
    .then((registration) => {
      console.log('Service Worker registrado con éxito:', registration);
    })
    .catch((error) => {
      console.error('Error al registrar el Service Worker:', error);
    });
}

// Usa createRoot para renderizar la aplicación
const root = ReactDOM.createRoot(document.getElementById('root')); 
root.render(
  <React.StrictMode>
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </AuthProvider>
  </React.StrictMode>
);
